/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Line_Deletion_Needs_RequestInputs */

const en_error_line_deletion_needs_request = /** @type {(inputs: Error_Line_Deletion_Needs_RequestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After the first submission, ask Tomorrow to delete a line.`)
};

/**
* | output |
* | --- |
* | "After the first submission, ask Tomorrow to delete a line." |
*
* @param {Error_Line_Deletion_Needs_RequestInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_line_deletion_needs_request = /** @type {((inputs?: Error_Line_Deletion_Needs_RequestInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Line_Deletion_Needs_RequestInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_line_deletion_needs_request(inputs)
});